import { AlertTriangle, Inbox } from "lucide-react";

export default function StatePanel({ error, title = "Sin registros", detail = "Todavia no hay informacion para mostrar" }) {
  const Icon = error ? AlertTriangle : Inbox;
  return <div className="grid min-h-48 place-items-center rounded-2xl border border-dashed border-zinc-300 bg-white/40 p-8 text-center"><div><Icon className={`mx-auto mb-3 ${error ? "text-barberRed" : "text-zinc-400"}`} /><p className="font-black uppercase text-zinc-900">{error || title}</p><p className="mt-1 text-sm text-zinc-500">{error ? "Verifique la conexion o intente nuevamente." : detail}</p></div></div>;
}



